
import debounce from 'lodash/debounce'
import 'components/catalog.tag'
import moment from 'moment'
riot.tag2('stock-list', '  <catalog object="Stock" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" remove="{permission(remove, &quot;stock&quot;, &quot;0001&quot;)}" dblclick="{permission(stockOpen, &quot;stock&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="stock-list" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateStock" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateStock" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/stock/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell name="date" onclick="{handlers.copyText}" style="width:100px;">{row.date}</datatable-cell>\n      <datatable-cell name="countOrders" onclick="{handlers.copyText}" style="width:100px;">{row.countOrders}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countCollected}" name="countCollected" onclick="{handlers.copyText}" style="width:100px;">{row.countCollected}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countChecked}" name="countChecked" onclick="{handlers.copyText}" style="width:100px;">{row.countChecked}</datatable-cell>\n      <datatable-cell class="{bg-success: row.countOrders == row.countSent}" name="countSent" onclick="{handlers.copyText}" style="width:100px;">{row.countSent}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Stock';
self.idManager = app.config.idUser;
self.startDate = '';
self.endDate = '';

self.cols = [{ name: 'id', value: 'Партия' }, { name: 'date', value: 'Дата' }, { name: 'countOrders', value: 'Заказов' }, { name: 'countCollected', value: 'Собранных' }, { name: 'countChecked', value: 'Проверенных' }, { name: 'countSent', value: 'Отправленных' }, { name: 'commentary', value: 'Примечание администратора' }];

self.handlers = {
    copyText: function copyText(elem) {
        //copyToClipboard(elem.target)
    }
};

self.stockOpen = function (e) {
    riot.route('/orders/stock/' + e.item.row.id);
};

self.getAggregation = function (response, xhr) {
    self.totalAmount = parseFloat(response.totalAmount).toFixed(2);
    self.currTotal = response.currTotal;
    if (response.counts) observable.trigger('tabs-update', response.counts);
};

observable.on('stock-reload', function () {
    self.tags.catalog.reload();
});

self.on('mount', function () {
    self.idManager = app.config.idUser;
    self.update();
});
});


// WEBPACK FOOTER //
// ./pages/orders/stock-list.tag